// @flow
import React from 'react';

import { StyledSpan } from '../../../common-utils/styledComponents';
import { getProvidedByTooltipTextGivenLabelText } from '../../../common-utils/utils';
import { SYSTEM_GENERATED_LABEL_TEXT } from '../../../constants';
import { LabelWithPopup } from '../../presentational/LabelWithPopup';

const conflictStyles = {
  paddingLeft: '14.4px',
  color: '#912D2B',
  fontWeight: 'bold',
  backgroundColor: '#fff6f6',
  border: '1px solid #912D2B',
};

const defaultStyles = {
  paddingLeft: '14.4px',
};

export const VBDRibbonContainer = ({ doesVBDRowConflictWithAnyOtherUserRow }) => (
  <StyledSpan
    style={{
      marginLeft: '-2.75rem',
      marginTop: '0.5rem',
      position: 'absolute',
    }}
  >
    <LabelWithPopup
      {...(!doesVBDRowConflictWithAnyOtherUserRow && { labelColor: 'teal' })}
      labelRibbon={true}
      labelStyle={doesVBDRowConflictWithAnyOtherUserRow ? conflictStyles : defaultStyles}
      labelText={SYSTEM_GENERATED_LABEL_TEXT}
      popupPosition="top right"
      popupSize="tiny"
      popupTooltipText={getProvidedByTooltipTextGivenLabelText(SYSTEM_GENERATED_LABEL_TEXT)}
    />
  </StyledSpan>
);
